export default __webpack_public_path__ + "static/media/fedpa.e1ac8d42.ico";